import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'decapitalize'
})
export class DecapitalizePipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
